import { render, staticRenderFns } from "./scxxcx.vue?vue&type=template&id=696ee066&scoped=true"
import script from "./scxxcx.vue?vue&type=script&lang=js"
export * from "./scxxcx.vue?vue&type=script&lang=js"
import style0 from "./scxxcx.vue?vue&type=style&index=0&id=696ee066&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ee066",
  null
  
)

export default component.exports